import React, { useState } from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbInputTextarea from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea'
import MDefaultForm from '../m_defaultForm'
import { checkRequireLabel } from '../../../../../../utils/form/checkRequireLabel'
import { extractFields } from '../../../../../../utils/form/extractFields'
import { emailRegex } from '../../../../../../utils/form/emailRegex'

const MFairPlayMedaille = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)
  const [email, setEmail] = useState('')

  return (
    <MDefaultForm
      buttonLabel="Anfrage absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      DOImail={email}
      formType={formType}
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}

          {data.text && <DfbParagraph add_class="m-Formblock-text" text={data.text} />}

          {fields.game && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.game.identifier, {
                  required: fields.game.required ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.game.identifier]}
                errorMessage={errors?.[fields.game.identifier]?.message}
                label={checkRequireLabel(fields.game)}
                focused
              />
            </div>
          )}

          {fields.date && (
            <div className="m-Formblock-input">
              <DfbInput
                type="date"
                {...register(fields.date.identifier, {
                  required: fields.date.required ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.date.identifier]}
                errorMessage={errors?.[fields.date.identifier]?.message}
                label={checkRequireLabel(fields.date)}
                focused
              />
            </div>
          )}

          {(fields.nationalassociation || fields.league) && (
            <div className="m-Formblock-input-half">
              {fields.nationalassociation && (
                <div className="m-Formblock-input">
                  <DfbInput
                    {...register(fields.nationalassociation.identifier, {
                      required: fields.nationalassociation.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[fields.nationalassociation.identifier]}
                    errorMessage={errors?.[fields.nationalassociation.identifier]?.message}
                    label={checkRequireLabel(fields.nationalassociation)}
                    focused
                  />
                </div>
              )}
              {fields.league && (
                <div className="m-Formblock-input">
                  <DfbInput
                    {...register(fields.league.identifier, {
                      required: fields.league.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[fields.league.identifier]}
                    errorMessage={errors?.[fields.league.identifier]?.message}
                    label={checkRequireLabel(fields.league)}
                    focused
                  />
                </div>
              )}
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          {fields.agerange && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.agerange.identifier, {
                  required: fields.agerange.required ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.agerange.identifier]}
                errorMessage={errors?.[fields.agerange.identifier]?.message}
                label={checkRequireLabel(fields.agerange)}
                focused
              />
            </div>
          )}

          {fields.displaygesture && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.displaygesture.identifier, {
                  required: fields.displaygesture.required === 1 ? t('form.errorMessage.input') : false,
                })}
                label={checkRequireLabel(fields.displaygesture)}
                error={errors[fields.displaygesture.identifier]}
                errorMessage={errors?.[fields.displaygesture.identifier]?.message}
              />
            </div>
          )}

          {fields.firstnamereported && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.firstnamereported.identifier, {
                  required: fields.firstnamereported.required ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.firstnamereported.identifier]}
                errorMessage={errors?.[fields.firstnamereported.identifier]?.message}
                label={checkRequireLabel(fields.firstnamereported)}
                focused
              />
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          {(fields.firstnamereporter || fields.lastnamereporter || fields.email) && (
            <div className="m-Formblock-row-third">
              {[fields.firstnamereporter, fields.lastnamereporter].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-row-third-cell" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={checkRequireLabel(formItem)}
                    focused
                  />
                </div>
              ))}
              <div className="m-Formblock-row-third-cell">
                <DfbInput
                  {...register(fields.email.identifier, {
                    required: fields.email.required ? t('form.errorMessage.input') : false,
                    pattern: {
                      value: emailRegex,
                      message: t('form.errorMessage.emailPattern'),
                    },
                    onChange: (e) => {
                      setEmail(e.target.value)
                    },
                  })}
                  error={errors[fields.email.identifier]}
                  errorMessage={errors?.[fields.email.identifier]?.message}
                  label={checkRequireLabel(fields.email)}
                  focused
                />
              </div>
            </div>
          )}

          {fields.street && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.street.identifier, {
                  required: fields.street.required ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.street.identifier]}
                errorMessage={errors?.[fields.street.identifier]?.message}
                label={checkRequireLabel(fields.street)}
                focused
              />
            </div>
          )}

          {(fields.postcode || fields.location) && (
            <div className="m-Formblock-input-half">
              {[fields.postcode, fields.location].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      ...(formItem.identifier === 'postcode' && {
                        pattern: {
                          value: /^\d+$/,
                          message: t('form.errorMessage.postcodePattern'),
                        },
                      }),
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={checkRequireLabel(formItem)}
                    focused
                  />
                </div>
              ))}
            </div>
          )}

          {fields.phone && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.phone.identifier, {
                  required: fields.phone.required === 1 ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.phone.identifier]}
                errorMessage={errors?.[fields.phone.identifier]?.message}
                label={checkRequireLabel(fields.phone)}
                focused
              />
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          <div className="m-Formblock-checkbox">
            <DfbParagraph text={t('form.dataProtection')} />
          </div>
        </>
      )}
    </MDefaultForm>
  )
}

export default MFairPlayMedaille
